"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var owa_analytics_1 = require("owa-analytics");
var owa_mail_search_store_1 = require("owa-mail-search-store");
var saveSearch_1 = require("owa-mail-search-store/lib/actions/saveSearch");
var getSuggestionsSet_1 = require("owa-mail-search-store/lib/helpers/getSuggestionsSet");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var React = require("react");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/components/ContextualMenu");
var searchConstants_1 = require("owa-mail-search-store/lib/helpers/searchConstants");
var searchViewConstants_1 = require("../utils/searchViewConstants");
var owa_mail_search_store_2 = require("owa-mail-search-store");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var searchBoxStyles = require('./SearchBox.scss');
var styles = require('./SuggestionsContextMenu.scss');
var classNames = require('classnames/bind');
var MAX_SUGGESTIONS_TO_SHOW = 6;
var START_MATCH_DELIMITER = String.fromCharCode(0xe000); // The server uses this char to mark start of highlighting.
var END_MATCH_DELIMITER = String.fromCharCode(0xe001); // The server uses this char to mark end of highlighting.
var SPACE_REGEX = /^\s/;
var NONBREAKING_SPACE_CHAR = String.fromCharCode(160);
var SuggestionsContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionsContextMenu, _super);
    function SuggestionsContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suggestions = [];
        _this.createPinnedItem = function (query) {
            return {
                key: query,
                name: query,
                className: styles.keywordSuggestion,
                onRender: function () { return (React.createElement("div", { className: styles.pinnedItem, tabIndex: 0 },
                    React.createElement("div", { tabIndex: 0, key: query, className: styles.pinnedKeyword, title: query, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, onMouseDown: function () {
                            var eventName = owa_mail_search_store_1.datapoints.ExecuteSaveSearch.datapoint.name;
                            owa_analytics_1.logUsage(eventName);
                            _this.props.onTextSuggestionClick(query);
                        } },
                        React.createElement(Icon_1.Icon, { className: searchBoxStyles.suggestionHistoryClockIcon, iconName: "Pinned" /* Pinned */ }),
                        React.createElement("div", { className: styles.keywordNonMatchSuggestion }, query)),
                    React.createElement("div", { tabIndex: 0, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, onClick: function () {
                            return _this.props.onUnpinSearchClicked(query, 'SearchBoxSuggestionDropDown');
                        } },
                        React.createElement(Icon_1.Icon, { className: classNames(searchBoxStyles.pinIcon, styles.pinActionIconContainer), iconName: "Pinned" /* Pinned */, title: 'Unpin Search' })))); },
            };
        };
        _this.createKeywordSuggestionItem = function (traceId, suggestion, index) {
            var matchText = null;
            var notMatchText = suggestion.DisplayText;
            var startMatchIndex = suggestion.DisplayText.indexOf(START_MATCH_DELIMITER);
            var endMatchIndex = suggestion.DisplayText.lastIndexOf(END_MATCH_DELIMITER);
            var title = notMatchText;
            if (endMatchIndex > 0) {
                matchText = suggestion.DisplayText.substring(startMatchIndex + 1, endMatchIndex);
                // If the first character of the notMatchText is a space,
                // replace it with a non-breaking space, since any other whitespace
                // will be stripped when notMatchText is rendered.
                notMatchText = suggestion.DisplayText.substr(endMatchIndex + 1).replace(SPACE_REGEX, NONBREAKING_SPACE_CHAR);
            }
            return {
                key: suggestion.DisplayText,
                name: suggestion.DisplayText,
                className: owa_mail_search_store_1.searchStore.selectedSuggestionIndex == index ? styles.suggestionSelected : '',
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.DisplayText, className: styles.keywordSuggestion, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onTextSuggestionClick(suggestion.QueryText);
                        if (owa_mail_feature_flags_1.isMailFeatureEnabled('sea-qf')) {
                            owa_mail_search_store_2.lazyLogEntityClicked.importAndExecute(traceId, suggestion.ReferenceId);
                        }
                    }, title: title },
                    React.createElement(Icon_1.Icon, { className: searchBoxStyles.suggestionHistoryClockIcon, iconName: "Clock" /* Clock */ }),
                    React.createElement("div", { className: styles.keywordMatchSuggestion }, matchText),
                    React.createElement("div", { className: styles.keywordNonMatchSuggestion }, notMatchText))); },
            };
        };
        _this.createPeopleSuggestionItem = function (traceId, suggestion, index) {
            return {
                key: suggestion.ReferenceId,
                name: suggestion.DisplayName,
                className: owa_mail_search_store_1.searchStore.selectedSuggestionIndex == index ? styles.suggestionSelected : '',
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.ReferenceId, className: styles.personaSuggestion, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onPeopleSuggestionClick(suggestion);
                        if (owa_mail_feature_flags_1.isMailFeatureEnabled('sea-qf')) {
                            owa_mail_search_store_2.lazyLogEntityClicked.importAndExecute(traceId, suggestion.ReferenceId);
                        }
                    } },
                    React.createElement(PersonaControl_1.default, { name: suggestion.DisplayName, emailAddress: suggestion.EmailAddresses[0], size: Persona_1.PersonaSize.size28, showPresence: false, showPersonaDetails: true }))); },
            };
        };
        return _this;
    }
    SuggestionsContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu_1.ContextualMenu, { useTargetWidth: true, shouldFocusOnMount: false, target: this.props.targetElement, gapSpace: 2, directionalHintFixed: true, directionalHint: 4 /* bottomLeftEdge */, items: this.searchMenuItems }));
    };
    Object.defineProperty(SuggestionsContextMenu.prototype, "searchMenuItems", {
        get: function () {
            var _this = this;
            var items = this.suggestions;
            var suggestionSet = getSuggestionsSet_1.default();
            if (suggestionSet && suggestionSet.IsComplete) {
                items = [];
                var savedSearches = saveSearch_1.getSavedSearches();
                if (this.props.shouldShowPinSearchIcon && savedSearches) {
                    // first render the pinned items
                    savedSearches.forEach(function (query) {
                        items.push(_this.createPinnedItem(query));
                    });
                    items.push({
                        key: 'divider_1',
                        itemType: ContextualMenu_1.ContextualMenuItemType.Divider,
                    });
                }
                // Show people suggestions only when we have not already selected 2 persona suggestions
                var shouldShowPeopleSuggestions_1 = owa_mail_search_store_1.searchStore.personaPillIds.length < searchConstants_1.PERSONA_PILL_LIMIT;
                suggestionSet.Suggestions.slice(0, MAX_SUGGESTIONS_TO_SHOW).map(function (suggestion, index) {
                    if (suggestion.kind == searchConstants_1.PEOPLE_KIND_SUGGESTION && shouldShowPeopleSuggestions_1) {
                        items.push(_this.createPeopleSuggestionItem(suggestionSet.TraceId, suggestion, index));
                    }
                    else if (suggestion.kind == searchConstants_1.KEYWORD_KIND_SUGGESTION) {
                        items.push(_this.createKeywordSuggestionItem(suggestionSet.TraceId, suggestion, index));
                    }
                });
                if (owa_mail_feature_flags_1.isMailFeatureEnabled('sea-qf')) {
                    owa_mail_search_store_2.lazyLogResponseRendered.importAndExecute(suggestionSet.TraceId);
                }
            }
            return (this.suggestions = items);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], SuggestionsContextMenu.prototype, "searchMenuItems", null);
    SuggestionsContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], SuggestionsContextMenu);
    return SuggestionsContextMenu;
}(React.Component));
exports.default = SuggestionsContextMenu;
//# sourceMappingURL=SuggestionsContextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-search-view/lib/components/SuggestionsContextMenu.js
// module id = 4838
// module chunks = 37